module.exports = __webpack_public_path__ + "static/media/home-man.ab5d8c14.svg";